import React from "react";
import HeadingSkeleton from "../../../../components/skeletons/HeadingSkeleton";
import AvatarSkeleton from "../../../../components/skeletons/AvatarSkeleton";

export default function MastermindSkeleton() {

    return(
        <div className={'vault'}>
            <div className={'vault-section'}>
                <div className={'vault-pages'}>
                    <div className={'vault-section'}>
                        {
                            [1,2,3,4,5,6,7,8,9,10].map((item, index)=>{
                                return(
                                    <div className={'vault-card'} >
                                        <div className={'card-img'}>
                                            <AvatarSkeleton avatarShape={'square'} size='large' height={150} width={'100%'}/>
                                        </div>
                                        <div className={'card-content'}>
                                            <div>
                                                <h4><HeadingSkeleton block={false} height={15} maxWidth={170} /></h4>
                                                <h5 className={'d-flex gap-2'}> <HeadingSkeleton block={false} height={10} maxWidth={100} /></h5>
                                            </div>
                                            <h6><HeadingSkeleton block={false} height={10} maxWidth={100} /> <span> <AvatarSkeleton avatarShape={'circle'}  height={35} width={35}/></span></h6>
                                        </div>
                                    </div>                        )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>

    )
}